(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pw-reviews-list"] && !Shopify.designMode) return;
  try {
    (function(){
  document.querySelectorAll('.pw-revwrap .review__txt').forEach(function(txt){
    if(txt.scrollHeight<=txt.clientHeight+2)return;
    var card=txt.closest('.review');
    var btn=document.createElement('button');
    btn.type='button';btn.className='review__more';btn.textContent='Lire la suite';
    btn.addEventListener('click',function(){
      var open=card.classList.toggle('is-open');
      btn.textContent=open?'Réduire':'Lire la suite';
      if(!open)txt.scrollTop=0;
    });
    txt.after(btn);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
